/**
 * Synthetic stress-test fixture for TableElem perf work.
 * 20 cols × 200 rows — roughly the shape at which the table used to get
 * janky (15-20 cols, 30-40 rows), with extra rows to make vertical
 * scroll cost visible. Tweak NUM_COLS / NUM_ROWS freely.
 */

const NUM_COLS = 100;
const NUM_ROWS = 1000;

const WORDS = [
  "amber", "birch", "cedar", "delta", "ember",
  "fjord", "grove", "haven", "islet", "juniper",
  "kelp", "lagoon", "meadow", "nectar", "orchid",
  "pebble", "quartz", "ridge", "summit", "tundra",
];

export const tableConfig = {
  rowIdPath: "_id",
  freezeFirstCol: true,
  cellData: Array.from({ length: NUM_COLS }, (_, c) => ({
    colId: `col_${c + 1}`,
    headerDisplay: `Column ${c + 1}`,
    valuePath: `main.col_${c + 1}`,
    propertyPath: null,
    sortConfig: {
      fn: "alphabetical",
      path: `main.col_${c + 1}`,
    },
    // means when the table is first rendered, it is sorted from first to last, by this col by default
    ...(c === 0 ? { defaultSort: true } : {}),
  })),
};

export const dummyData = Array.from({ length: NUM_ROWS }, (_, r) => ({
  _id: `row_${r + 1}`,
  main: Object.fromEntries(
    Array.from({ length: NUM_COLS }, (_, c) => [
      `col_${c + 1}`,
      `${WORDS[(r + c) % WORDS.length]} ${r + 1}-${c + 1}`,
    ])
  ),
}));
